import React, { useState } from 'react'
import style from './cardListProjectManagers.module.scss'
import { useAppSelector } from '../../starter/hooks/redux'
import CardProjectManagerSmall from '../CardProjectManagerSmall/CardProjectManagerSmall'
import { Input } from 'antd'
import { IProjectManager } from '../../starter/model/interfaces'

const CardListProjectManagers = () => {
  const { projectManagers } = useAppSelector((state) => state.projectManagers)
  const [filter, setFilter] = useState<string>('')

  const filterPattern = (item: IProjectManager) => {
    return `${item.firstName} ${item.lastName}`.toLowerCase().includes(filter.toLowerCase())
  }

  return (
    <div className={style.wrapper}>
      <Input
        value={filter}
        onChange={(e) => {
          setFilter(e.target.value)
        }}
      />
      <div className={style.list}>
        {projectManagers &&
          projectManagers
            .filter(filterPattern)
            .map((projectManager) => <CardProjectManagerSmall key={projectManager._id} manager={projectManager} />)}
      </div>
    </div>
  )
}

export default CardListProjectManagers
